<script setup>
import { createPostJsonLd } from '@@/utils/PageUtils';
import { parseOpenMountainApiError } from '@@/utils/CommonUtils';
import { useNewsStore } from '@@/stores/News';
import { useAsyncData } from 'nuxt/app';

const newsStore = useNewsStore();
const { idOrSlug } = useRoute().params;

const { data, error } = await useAsyncData(() => newsStore.fetchArticle({ idOrSlug }));

if (error?.value) {
  throw createError(parseOpenMountainApiError(error.value));
}

const { article, recentNewsArticles } = data.value;
const { image_url } = article;
const jsonLd = createPostJsonLd({ post: article });

useSeoMeta({
  ogImage: image_url,
  twitterImage: image_url,
});

useHead({
  script: [{
    children: JSON.stringify(jsonLd, null, 2),
    id: 'jsonld',
    type: 'application/ld+json',
  }],
});

const { inAppView } = useInAppView();
const containerClass = inAppView.value ? 'tw-p-2.5' : 'lg:tw-w-2/3 lg:tw-mr-4 tw-mb-4 lg:tw-mb-0';
const pageParams = article ? { article } : null;
</script>

<template>
  <PageContent
    :can-set-meta-image="false"
    class="tw-overflow-hidden"
    :full-screen="inAppView"
    :page-params="pageParams"
  >
    <div
      v-if="!inAppView"
      class="tw-my-3 lg:tw-mt-6 lg:tw-mb-7"
    >
      <h3 class="page-title heading-color">
        News
      </h3>
    </div>
    <div class="lg:tw-flex">
      <div
        :class="containerClass"
      >
        <NewsArticle
          class="tw-mb-8"
          :article="article"
        />
        <PostNavigationButton
          v-if="!inAppView"
          class="tw-mb-8"
          direction="previous"
          :display-block="true"
          to="/news"
        >
          Back to All News
        </PostNavigationButton>
        <PostAuthor
          v-if="!inAppView"
          class="tw-mb-8"
          :post="article"
        />
      </div>
      <div
        v-if="!inAppView"
        class="lg:tw-w-1/3 lg:tw-ml-4"
      >
        <h3 class="tw-mb-3 section-title heading-color">
          Free OpenSnow App
        </h3>
        <DownloadAppButtons
          container-class="tw-mb-8"
        />
        <CompareTopSnow />
      </div>
    </div>
    <div
      v-if="!inAppView"
      class="tw-my-8"
    >
      <PostLinkList
        :posts="recentNewsArticles"
      />
    </div>
  </PageContent>
</template>
